import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { State } from 'state';
import { invitedSignUp } from 'state/actions/invited-sign-up';
import { getPortalId } from 'state/selectors/context';

import { getContactLink } from 'state/selectors/env';
import { getFormSubmitState } from 'state/selectors/invited-sign-up';
import { withBrowserMetricsScreenTransitionStatus } from '@atlassian/help-center-common-util/analytics/browsermetrics-screen-transition-status-context';
import InvitedSignUpFormComponent from './invited-sign-up-form';

const selector = createSelector(
    (state: State) => getPortalId(state),
    (state: State) => getFormSubmitState(state),
    (state: State) => getContactLink(state),
    (portalId, formSubmitState, contactLink) => ({
        portalId,
        formSubmitState,
        contactLink,
    })
);

export default connect(selector, {
    invitedSignUpAction: invitedSignUp,
})(withBrowserMetricsScreenTransitionStatus(InvitedSignUpFormComponent));
